import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./stylefiles/partner.css"
import { useEffect } from "react";

function Visit() {

    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

  return (
    <div>
      <Container fluid className="pageContainer">
        <div className="pageTitleDiv">VISIT READING</div>
        <Container fluid className="pageImageContainer">

        </Container>


        <div className="sectionDiv" style={{ textAlign: "justify", margin: "20px 30px 10px 30px" }}>
          <h1 style={{ marginBottom: "20px" }}>雷丁简介 About Reading</h1>
          <h5>
            Reading is a vibrant town in Berkshire, England, set on the River Thames about 40 miles west of London.
            Blending rich history with modern culture, it's known for the Reading Festival, great shopping, and beautiful green spaces like Forbury Gardens and the Thames Path.
          </h5>
          <p></p>
          {/* <h4>Our business parterner - </h4> */}


          <ul style={{ listStyleType: "none", padding: 0 }}>
            <li>
              <Link to="/PremierSuitesReading" className="nav-link-2"><h4><strong>PREMIER SUITES Reading </strong> </h4></Link>
            </li>

          </ul>



          <h5>
            For visitors looking for a comfortable stay, <strong>PREMIER SUITES Reading</strong> is our preferred accommodation provider, offering quality service and convenient access to everything Reading has to offer.

            Guests can also enjoy a  10% discount by visiting  <a href="https://www.premiersuiteseurope.com/en/locations/united-kingdom/reading/serviced-apartments-reading" target="_blank" rel="noopener noreferrer">www.premiersuitesreading.com</a>, quoting RCS10 in the discount box, or by contacting
            Sales Manager Laura Grantham.


          </h5>
          <p></p>





        </div>



      </Container>
    </div>
  );
}

export default Visit;
